import React from "react"
import PropTypes from "prop-types"
import * as styles from "./Footer-tw-styles"
import ArrowRight from "../../../assets/ArrowRight"
import RichTextModel from "../../RichTextModel/RichTextModel"
import ResponsiveImage from "../../UI/ResponsiveImage/ResponsiveImage"
import SocialLink from "../../UI/SocialLink/SocialLink"
import Link from "../../UI/Link/Link"

const Footer = props => {
    const style = styles.defaultStyle
    const {
        decorationImage,
        footerImageLink,
        footerImage,
        navigationsCollection,
        socialLinks,
        copyright,
        description,
        descriptionCta,
    } = props
    return (
        <footer className={style.footer}>
            <div className={style.borderTop}>&nbsp;</div>
            <div className={style.wrapper}>
                {!!decorationImage && (
                    <div className={style.decoration}>
                        <ResponsiveImage contentfulImagesComponent={decorationImage} />
                    </div>
                )}
                <div className={style.topContent}>
                    <div>
                        <div className={style.logoWrapper}>
                            {!!footerImageLink && !!footerImage && (
                                <Link {...footerImageLink}>
                                    <ResponsiveImage contentfulImagesComponent={footerImage} />
                                </Link>
                            )}
                        </div>
                        {!!description || !!descriptionCta ? <hr className={style.hrMob} /> : null}
                        <div className={style.description}>
                            {!!description && <RichTextModel richText={description} style={style.descriptionCopy} />}
                            {!!descriptionCta && (
                                <Link {...descriptionCta} className={style.descriptionCta}>
                                    {descriptionCta?.label || descriptionCta?.title || ""}
                                    <ArrowRight />
                                </Link>
                            )}
                        </div>
                    </div>
                    <hr className={style.hrMob} />
                    <div className={style.navigations}>
                        {navigationsCollection?.items.map((item, index) => (
                            <div key={`${item.sys.id}_footer_navigation_${index}`} className={style.navigationCol}>
                                {item.__typename === "FooterLinksContainer" && (
                                    <>
                                        <div className={style.navigationLabel}>{item?.title || ""}</div>
                                        <ul className={style.navigationList}>
                                            {item.linksCollection.items.map((link, index) => (
                                                <li key={`${item.sys.id}_footer_link_${index}`}>
                                                    <Link {...link} className={style.navigationLink} />
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <hr className={style.hr} />
                <div className={style.bottomContent}>
                    <div>{copyright && <div className={style.copyright}>{copyright}</div>}</div>
                    <div className={style.socialLinksWrapper}>
                        {socialLinks?.linksCollection?.items.map((item, index) => (
                            <SocialLink
                                key={`${socialLinks.sys.id}_footer_social_link_${index}`}
                                {...item}
                                className={style.socialLink}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    )
}

Footer.propTypes = {
    decorationImage: PropTypes.object,
    footerImageLink: PropTypes.object,
    footerImage: PropTypes.object,
    navigationsCollection: PropTypes.object,
    socialLinks: PropTypes.object,
    copyright: PropTypes.string,
    description: PropTypes.object,
    descriptionCta: PropTypes.object,
}

export default Footer
